/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('store.quantity-nav', function (el) {
        var quantityNav = new QuantityNav(el);
        quantityNav.init();
    });
    var QuantityNav = /** @class */ (function () {
        function QuantityNav(el) {
            this.buttonDown = el.querySelector('button.quantity-down');
            this.buttonUp = el.querySelector('button.quantity-up');
            this.qtyInput = el.querySelector('input[type="number"]');
        }
        QuantityNav.prototype.init = function () {
            var _this = this;
            util.delegate(this.buttonUp, 'click', 'button', function () {
                _this.qtyInput.stepUp();
                _this.checkMinMax();
            });
            util.delegate(this.buttonDown, 'click', 'button', function () {
                _this.qtyInput.stepDown();
                _this.checkMinMax();
            });
        };
        QuantityNav.prototype.checkMinMax = function () {
            if (this.qtyInput.value === this.qtyInput.max) {
                this.buttonUp.disabled = true;
            }
            if (this.qtyInput.value !== this.qtyInput.max) {
                this.buttonUp.disabled = false;
            }
            if (this.qtyInput.value === this.qtyInput.min) {
                this.buttonDown.disabled = true;
            }
            if (this.qtyInput.value !== this.qtyInput.min) {
                this.buttonDown.disabled = false;
            }
        };
        return QuantityNav;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
